var _rect, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g2, _path21, _path22, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOutlook = function SvgOutlook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 64,
    fill: "#EDF8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.587 47.031H62.7a.047.047 0 0 0-.046.047v.888c0 .025.02.046.047.046h.887c.026 0 .047-.02.047-.046v-.888a.047.047 0 0 0-.047-.047zm0 1.444H62.7a.047.047 0 0 0-.046.046v.841c0 .026.02.047.047.047h.887a.047.047 0 0 0 .047-.047v-.84a.047.047 0 0 0-.047-.047zm0 1.443H62.7a.047.047 0 0 0-.046.047v.84c0 .027.02.048.047.048h.887a.047.047 0 0 0 .047-.047v-.841a.047.047 0 0 0-.047-.047zm0 1.398H62.7a.047.047 0 0 0-.046.047v.888c0 .025.02.046.047.046h.887c.026 0 .047-.02.047-.046v-.888a.047.047 0 0 0-.047-.047z",
    fill: "#F5F5F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.456,
    y: 46.615,
    width: 6.335,
    height: 6.335,
    rx: 0.325,
    fill: "#fff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.19 49.829a.111.111 0 0 0-.054-.096l-.003-.001-1.745-1.023a.236.236 0 0 0-.262 0l-1.745 1.023-.002.001a.113.113 0 0 0-.039.153c.01.017.024.03.041.04l1.745 1.023a.236.236 0 0 0 .261 0l1.746-1.023a.11.11 0 0 0 .056-.097z",
    fill: "#123B6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.519 49.153h1.159v1.062h-1.16v-1.062z",
    fill: "#0364B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.007 48.148v-.434a.22.22 0 0 0-.221-.218h-3.098a.22.22 0 0 0-.221.218v.434h3.54z",
    fill: "#0358A7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.467 48.056h1.21v1.118h-1.21v-1.118z",
    fill: "#0078D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.677 48.056h1.211v1.118h-1.21v-1.118z",
    fill: "#28A8EA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.889 48.056h1.118v1.118h-1.118v-1.118z",
    fill: "#50D9FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.889 49.173h1.118v1.118h-1.118v-1.118z",
    fill: "#28A8EA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.678 49.173h1.21v1.118h-1.21v-1.118z",
    fill: "#0078D4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M63.677 50.291h1.211v1.118h-1.21v-1.118z",
    fill: "#0364B8"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M62.519 50.216h1.159v.966h-1.16v-.966z",
    fill: "#14447D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.889 50.291h1.118v1.025h-1.118V50.29z",
    fill: "#0078D4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m66.138 49.914-.002.002-1.767.945a.256.256 0 0 1-.132.036h-.007l-.099-.055a.236.236 0 0 1-.023-.013l-1.77-.972h-.002l-.056-.031v1.913a.238.238 0 0 0 .245.23h3.43a.25.25 0 0 0 .145-.046l-.004-.002a.224.224 0 0 0 .097-.182v-1.913a.102.102 0 0 1-.055.088z",
    fill: "url(#paint0_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m66.139 49.914-.003.002-1.767.945a.246.246 0 0 1-.133.036.26.26 0 0 1-.132-.036l-1.767-.945-.003-.002a.101.101 0 0 1-.054-.088v1.913a.238.238 0 0 0 .245.23h3.423a.237.237 0 0 0 .245-.23v-1.913a.103.103 0 0 1-.054.088z",
    fill: "#1490DF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.525 51.969h3.43a.25.25 0 0 0 .145-.046l-1.969-1.08a.236.236 0 0 1-.023-.014l-1.77-.972h-.002l-.056-.031v1.907a.24.24 0 0 0 .245.236z",
    fill: "#28A8EA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M66.007 49.88v.104l-1.638.877c-.007.005-.016.008-.023.012a.249.249 0 0 1-.11.024h-.005l-.1-.055c-.008-.003-.015-.008-.024-.013l-1.64-.9v-.107l1.686.925.019.012.082.044a.156.156 0 0 0 .052-.014l1.701-.91z",
    fill: "#0A2767"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.77 48.645v2.454a.216.216 0 0 1-.217.217H62.28v-1.49l.048.025a.11.11 0 0 1 .051-.118l.003-.002.137-.08v-.478h-.052v-.745h1.087a.218.218 0 0 1 .217.217z",
    fill: "#000"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M63.864 48.646v2.267a.313.313 0 0 1-.31.31H62.28v-1.397l.048.026a.111.111 0 0 1 .051-.118l.003-.002.137-.08v-.478h-.052v-.839h1.087a.312.312 0 0 1 .31.31z",
    fill: "#000"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.77 48.645v2.267a.216.216 0 0 1-.216.218H62.28v-1.305l.048.026a.11.11 0 0 1 .051-.118l.003-.002.137-.08v-.478h-.052v-.745h1.087a.218.218 0 0 1 .217.217z",
    fill: "#000"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M63.678 48.645v2.267a.216.216 0 0 1-.217.218h-1.18v-1.305l.047.026a.11.11 0 0 1 .051-.118l.003-.002.137-.08v-.478h-.052v-.745h.994a.218.218 0 0 1 .217.217z",
    fill: "#000"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M63.46 48.428h-2.174a.217.217 0 0 0-.217.217v2.174a.217.217 0 0 0 .217.217h2.174a.217.217 0 0 0 .218-.217v-2.174a.217.217 0 0 0-.218-.217z",
    fill: "#0F78D4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M61.79 49.383a.59.59 0 0 1 .232-.256.701.701 0 0 1 .368-.093.653.653 0 0 1 .341.088.584.584 0 0 1 .226.245.79.79 0 0 1 .08.36.833.833 0 0 1-.082.377.598.598 0 0 1-.233.253.678.678 0 0 1-.354.09.669.669 0 0 1-.348-.088.594.594 0 0 1-.229-.245.771.771 0 0 1-.08-.356.856.856 0 0 1 .079-.375zm.247.602a.384.384 0 0 0 .13.169.34.34 0 0 0 .204.061.358.358 0 0 0 .218-.063.368.368 0 0 0 .127-.17.714.714 0 0 0 .002-.474.376.376 0 0 0-.122-.174.338.338 0 0 0-.216-.067.352.352 0 0 0-.209.062.387.387 0 0 0-.133.17.675.675 0 0 0-.001.486z",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.377 65.459a1.4 1.4 0 0 0-.669-1.204h-.007l-.026-.015L72.93 51.368a2.92 2.92 0 0 0-3.26 0L47.924 64.24l-.027.015a1.417 1.417 0 0 0 .034 2.427l21.745 12.872a2.92 2.92 0 0 0 3.26 0l21.745-12.872a1.4 1.4 0 0 0 .695-1.223z",
    fill: "#5E7D90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.46 56.865h14.27v13.08H50.46v-13.08zm41.998-13.297v-5.983a2.711 2.711 0 0 0-2.646-2.773h-37.03a2.711 2.711 0 0 0-2.646 2.773v5.983l21.89 5.838 20.432-5.838z",
    fill: "#7E98A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.136 43.568H64.73v13.134H50.136V43.568z",
    fill: "#91A9B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.323 43.568H64.73v13.134l14.593 13.135h13.135V56.702L79.323 43.568z",
    fill: "#A6BBC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.73 56.703h14.593v13.135H64.73V56.703z",
    fill: "#91A9B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.73 69.837h14.593v13.135H64.73V69.837z",
    fill: "#5E7D90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.46 69.945h14.27v11.891H50.46v-11.89z",
    fill: "#14447D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.323 69.837h13.135v13.135H79.323V69.837z",
    fill: "#91A9B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.708 66.602-.028.014-21.744 12.23a3.547 3.547 0 0 1-.292.163 3.03 3.03 0 0 1-1.18.292l-1.187-.694c-.1-.05-.198-.107-.292-.168L47.948 65.862h-.01l-.721-.403v24.757a2.992 2.992 0 0 0 3.01 2.971h42.186c.024 0 .046-.011.073-.011a3.694 3.694 0 0 0 1.021-.213c.142-.06.28-.132.41-.213.098-.056.266-.177.266-.177a2.946 2.946 0 0 0 1.194-2.357V65.46c0 .474-.256.91-.669 1.143z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.708 66.602-.028.016-21.744 12.23a3.05 3.05 0 0 1-3.26 0L47.93 66.617l-.026-.016a1.313 1.313 0 0 1-.687-1.143v24.757a2.99 2.99 0 0 0 3.009 2.971h42.141a2.99 2.99 0 0 0 3.01-2.97V65.458c0 .474-.256.91-.669 1.143z",
    fill: "#7E98A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.267 93.187h42.096a3.026 3.026 0 0 0 1.802-.583L70.275 78.61c-.1-.05-.198-.107-.292-.168L47.946 65.865h-.01l-.72-.406v24.672a3.053 3.053 0 0 0 3.05 3.056z",
    fill: "#A6BBC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.298 47.947h26.757a2.675 2.675 0 0 1 2.675 2.675v26.756a2.675 2.675 0 0 1-2.675 2.675H35.298a2.675 2.675 0 0 1-2.675-2.675V50.622a2.675 2.675 0 0 1 2.675-2.675z",
    fill: "#7E98A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.984 59.166a7.782 7.782 0 0 1 3.056-3.375 9.239 9.239 0 0 1 4.855-1.217 8.6 8.6 0 0 1 4.494 1.154 7.712 7.712 0 0 1 2.972 3.225 10.41 10.41 0 0 1 1.043 4.743 10.987 10.987 0 0 1-1.073 4.962 7.895 7.895 0 0 1-3.065 3.338 8.94 8.94 0 0 1-4.661 1.185 8.785 8.785 0 0 1-4.593-1.168A7.83 7.83 0 0 1 41 68.783a10.163 10.163 0 0 1-1.054-4.687c-.03-1.7.325-3.386 1.038-4.93zm3.257 7.925a5.05 5.05 0 0 0 1.72 2.221 4.49 4.49 0 0 0 2.685.809 4.703 4.703 0 0 0 2.866-.835 4.837 4.837 0 0 0 1.67-2.222 8.623 8.623 0 0 0 .532-3.098 9.432 9.432 0 0 0-.502-3.137 4.96 4.96 0 0 0-1.617-2.315 4.44 4.44 0 0 0-2.841-.876 4.633 4.633 0 0 0-2.748.816 5.093 5.093 0 0 0-1.752 2.24 8.902 8.902 0 0 0-.011 6.4l-.002-.003z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.323 43.568h13.135v13.134H79.323V43.568z",
    fill: "#B2CAD9"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "m64.462 50.811-.093.05a.253.253 0 0 1-.132.036h-.005l1.865 1.024a.227.227 0 0 0 .094-.16l-1.729-.95z",
    fill: "#000"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M66.097 51.922a.236.236 0 0 0 .065-.071l-1.798-.987a.257.257 0 0 1-.127.033h-.005l1.865 1.025z",
    fill: "#000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 64.237,
    y1: 49.826,
    x2: 64.237,
    y2: 51.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 71.297,
    y1: 65.459,
    x2: 71.297,
    y2: 93.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8EA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(32.623 34.812)",
    d: "M0 0h62.754v58.376H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 60.101,
    y: 46.393,
    width: 7.045,
    height: 7.045,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.133
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.178
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.02875 0 0 0 0 0.194861 0 0 0 0 0.2875 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
export default SvgOutlook;